module.exports = __webpack_public_path__ + "static/media/T14-T25-09.9f5d3aaf.svg";